import { FormattedMessage } from "react-intl";

interface SpeakerProps {
    name: string;
    avatarUrl?: string;
    initials: string;
    profile_url?: string;
    position: string;
    organisation: string;
}

export default function Speakers({ speakers }: { speakers: SpeakerProps[] }) {
    return (
        <div className="mt-6 pb-6 sm:mt-12 sm:pb-12 space-y-4 border-b border-b-gray-300">
            <h2 className="text-2xl font-medium text-gray-900">
                <FormattedMessage id="Speakers" />
            </h2>
            <div className="grid grid-col-1 gap-4 sm:grid-cols-2 sm:gap-6">
                {speakers.map((speaker) => (
                    <div
                        className="flex items-center space-x-5"
                        key={speaker.name}
                    >
                        <div>
                            {speaker.avatarUrl ? (
                                <img
                                    className="inline-block size-16 rounded-full object-cover"
                                    src={speaker.avatarUrl}
                                    alt={`Avatar for ${speaker.name}`}
                                />
                            ) : (
                                <span className="inline-flex size-16 items-center justify-center rounded-full bg-gray-500">
                                    <span className="text-3xl font-medium leading-none text-white">
                                        {speaker.initials}
                                    </span>
                                </span>
                            )}
                        </div>
                        <div>
                            {speaker.profile_url ? (
                                <h4 className="text-2xl font-medium">
                                    <a
                                        href={speaker.profile_url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="underline underline-offset-4"
                                    >
                                        {speaker.name}
                                    </a>
                                </h4>
                            ) : (
                                <h4 className="text-2xl font-medium">
                                    {speaker.name}
                                </h4>
                            )}
                            <p className="text-sm text-gray-500 font-light">
                                <FormattedMessage
                                    id=":position at :organisation"
                                    values={{
                                        position: speaker.position,
                                        organisation: speaker.organisation,
                                    }}
                                />
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
